<template>

    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>{{ restaurant.title }}</strong>
                    <RestaurantTableOrderBadge />
                </CCardHeader>
                <CCardBody>
                    <RestaurantsTabLinks />

                    <IntegrationNotice
                        :has-integration="!!restaurant.alias"
                        :is-business-admin="!adminOnly"
                    />

                    <CRow class="pl-3 pb-3" />

                    <CRow class="pl-3 pb-3" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Название</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.title }}</CCol>
                    </CRow>
                    <CRow
                        v-if="restaurant.why_is_it_off" 
                        form
                        class="form-group"
                        style="color: red; font-weight: 600">
                        <CCol sm="3" class="col-form-label">Последнее отключение:</CCol>
                        <CCol sm="9" class="col-form-label">
                            Причина: {{ restaurant.why_is_it_off }}.
                            <br> Кто отключил: {{ restaurant.who_turned_off }}
                            <br> Дата отключения: {{ restaurant.shutdown_date }}
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Код</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.code }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Юр. лицо</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.legal_entity }}</CCol>
                    </CRow>
                    <CRow
                        v-if="restaurant.partner"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Партнер</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CLink v-if="adminOnly" :to="`/partners/${restaurant.partner.id}`">{{ restaurant.partner.title }}</CLink>
                            <template v-else>{{ restaurant.partner.title }}</template>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Короткое название</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.short_title }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Типы кухни</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge 
                                v-for="(type, index) in restaurant.cuisineTypes" 
                                :key="index" 
                                color="info" 
                                class="mr-1 mb-1">
                                {{ type.name }}
                            </CBadge>
                            <span v-if="!restaurant.cuisineTypes || restaurant.cuisineTypes.length === 0">Не указано</span>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Категории ресторана</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge 
                                v-for="(type, index) in restaurant.restaurantTypes" 
                                :key="`restaurant-type-${index}`" 
                                color="primary" 
                                class="mr-1 mb-1">
                                {{ type.title }}
                            </CBadge>
                            <span v-if="!restaurant.restaurantTypes || restaurant.restaurantTypes.length === 0">Не указано</span>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Алиас</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.alias }}</CCol>
                    </CRow>
                    <CRow
                        v-if="restaurant.delivery_terminal_id"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Терминала доставки (iiko)</CCol>
                        <CCol sm="9" class="col-form-label">{{ deliveryTerminal }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Башня</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.towerObj ? restaurant.towerObj.name : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Зона</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.towerObj && restaurant.towerObj.zone ? restaurant.towerObj.zone.name : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Краткое описание</CCol>
                        <CCol
                            sm="9"
                            class="col-form-label">
                            {{ restaurant.description }}
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка сервиса (мобильное приложение)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="pictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>


                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для поиска</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="squarePictureUrl"
                                class="m2"
                                width="150" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для дексктопа (внутри сервиса)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="desktopPictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для дексктопа (список)</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="desktopPictureUrlInList"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Картинка для доставки</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CImg
                                :src="deliveryPictureUrl"
                                class="m2"
                                width="300" />
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Адрес для доставки</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.address }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <PromoCoversGrid :covers="restaurant.promoCovers" />
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Открывается в</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.open_at }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Закрывается в</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.close_at }}</CCol>
                    </CRow>

                    <!-- <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Расширенное время работы (Пример: с 07:00, до 02:00 след. дня)</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.extended_schedule ? 'Включено' : 'Отключено' }}</CCol>
                    </CRow> -->

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скрывать когда закрыт</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.hide)">
                                &nbsp;{{ restaurant.hide ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <WorkingHours 
                        :working-hours="workingHours"
                        :service-type="'restaurant'"
                    />

                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальный заказ</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.min_price ? restaurant.min_price : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Минимальная сумма для самовывоза</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.min_price_pickup ? restaurant.min_price_pickup : '' }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Телефон</CCol>
                        <CCol sm="9" class="col-form-label">{{ restaurant.phone }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки (часы:минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            `${appendNull(restaurant.delivery_time_hour)}:${appendNull(restaurant.delivery_time)}`
                        }}</CCol>
                    </CRow>
                    <CRow
                        v-if="restaurant.max_delivery_time_hour || restaurant.max_delivery_time"
                        form
                        class="form-group">
                        <CCol sm="3" class="col-form-label">Максимальное время доставки (часы:минуты)</CCol>
                        <CCol sm="9" class="col-form-label">{{
                            `${appendNull(restaurant.max_delivery_time_hour)}:${appendNull(restaurant.max_delivery_time)}`
                        }}</CCol>
                    </CRow>
                    <TimeSlots :time-slots="timeSlots" />
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл</CCol>
                        <CCol sm="9" class="col-form-label">{{ labelType(restaurant.service_label) }}</CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Калории за 100 г</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.calories_100g)">
                                &nbsp;{{ restaurant.calories_100g ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать состав</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.show_additional_info)">
                                &nbsp;{{ restaurant.show_additional_info ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Время доставки</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.show_delivery_time)">
                                &nbsp;{{ restaurant.show_delivery_time ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Скрывать рейтинг</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.hide_rating)">
                                &nbsp;{{ restaurant.hide_rating ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Запрос времени приготовления</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.time_cooking_request)">
                                &nbsp;{{ restaurant.time_cooking_request ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл - новый сервис </CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.is_new_label)">
                                &nbsp;{{ restaurant.is_new_label ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл - веган</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.vegan_label)">
                                &nbsp;{{ restaurant.vegan_label ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл - проверено МИРСИТИ</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.verified_mircity_label)">
                                &nbsp;{{ restaurant.verified_mircity_label ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Лейбл - Блюдо в подарок</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.dish_gift_label)">
                                &nbsp;{{ restaurant.dish_gift_label ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Убрать применение промокода</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.hide_promocode)">
                                &nbsp;{{ restaurant.hide_promocode ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Множественные ингридиенты</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.multiple_ingridients)">
                                &nbsp;{{ restaurant.multiple_ingridients ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Считать калории</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.counting_calories)">
                                &nbsp;{{ restaurant.counting_calories ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать на главной</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.show_main_page)">
                                &nbsp;{{ restaurant.show_main_page ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Для стола заказов</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.show_in_table_orders)">
                                &nbsp;{{ restaurant.show_in_table_orders ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Показывать популярные блюда в "профиле"</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.popular_profile)">
                                &nbsp;{{ restaurant.popular_profile ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Отключить применение тарифов по зонам</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.delivery_zone_disabled)">
                                &nbsp;{{ restaurant.delivery_zone_disabled ? "Да" : "Нет" }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                    <CRow form class="form-group">
                        <CCol sm="3" class="col-form-label">Активен</CCol>
                        <CCol sm="9" class="col-form-label">
                            <CBadge :color="getBadge(restaurant.enabled)">
                                &nbsp;{{ restaurant.enabled ? 'Да' : 'Нет' }}&nbsp;
                            </CBadge>
                        </CCol>
                    </CRow>
                </CCardBody>
                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="goBack">Назад</CButton>
                    <CButton
                        color="danger"
                        class="mr-3"
                        @click="stopModal = true">Стоп</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <StopServiceModal
            :id="$route.params.id"
            :open="stopModal"
            :type="BUSINESS_TYPE.RESTAURANT"
            @stop-modal-close="stopModal = false"
            @stop-modal-update="setSchedule"
        />
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import RestaurantsTabLinks from '@/components/RestaurantsTabLinks';
    import StopServiceModal from '@/components/StopServiceModal';
    import IntegrationNotice from '@/components/IntegrationNotice';
    // import Schedule from '@/components/Schedule';
    import WorkingHours from '@/components/WorkingHours';
    import TimeSlots from '@/components/TimeSlots';
    import PromoCoversGrid from '@/components/promo-covers/PromoCoversGrid';
    import { BUSINESS_TYPE } from '@/utils/order';
    import { BUSINESS_LABEL } from '@/utils/servicesLabel';

    export default {

        name: 'Restaurant',
        components: {
            RestaurantsTabLinks,
            IntegrationNotice,
            // Schedule,
            TimeSlots,
            StopServiceModal,
            PromoCoversGrid,
            WorkingHours,
        },

        data() {
            return {
                schedule: undefined,
                timeSlots: undefined,
                workingHours: [],
                deliveryTerminal: '',
                restaurant: {
                    service_label: '',
                    code: '',
                    title: '',
                    short_title: '',
                    alias: '',
                    delivery_terminal_id: '',
                    description: '',
                    picture: '',
                    square_picture: '',
                    desktop_picture: '',
                    desktop_picture_list: '',
                    open_at: '',
                    close_at: '',
                    restaurantTypes: [],
                    extended_schedule: false,
                    min_price: 0,
                    phone: '',
                    towerObj: {
                        name: '',
                    },
                    delivery_time: 0,
                    delivery_time_hour: 0,
                    enabled: true,
                    hide: false,
                    position: 0,
                    multiple_ingridients: false,
                },
                stopModal: false,
                BUSINESS_TYPE,
                adminOnly: false
            };
        },

        computed: {
            pictureUrl() {
                if (this.restaurant.picture) {
                    return (
                        process.env.VUE_APP_STATIC_BASE_URL +
                        '/' +
                        this.restaurant.picture
                    );
                } else {
                    return '';
                }
            },
            squarePictureUrl() {
                if(this.restaurant.square_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.square_picture;
                } else {
                    return '';
                }
            },
            desktopPictureUrl() {
                if(this.restaurant.desktop_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.desktop_picture;
                } else {
                    return '';
                }
            },
            desktopPictureUrlInList() {
                if(this.restaurant.desktop_picture_list) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.desktop_picture_list;
                } else {
                    return '';
                }
            },
            deliveryPictureUrl() {
                if(this.restaurant.delivery_picture) {
                    return process.env.VUE_APP_STATIC_BASE_URL + '/' + this.restaurant.delivery_picture;
                } else {
                    return '';
                }
            }
        },

        mounted() {
            this.adminOnly = !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            const id = this.$route.params.id;
            Vue.axios
                .get('/restaurants/' + id)
                .then(resp => {
                    this.restaurant = resp.data;
                    if (resp.data.schedule.length != 0) {
                        this.schedule = resp.data.schedule;
                    }
                    if (resp.data.timeSlots.length != 0) {
                        this.timeSlots = resp.data.timeSlots;
                    }
                    if (resp.data.workingHours.length != 0) {
                        this.workingHours = resp.data.workingHours;
                    }
                    if (this.restaurant.alias && this.restaurant.delivery_terminal_id) {
                        Vue.axios
                            .get(`/integration/iiko/delivery-terminals/${this.restaurant.alias}`)
                            .then(resp => {
                                const terminal = resp.data.deliveryTerminals
                                    .find(terminal => terminal.deliveryTerminalId === this.restaurant.delivery_terminal_id);
                                this.deliveryTerminal = `${terminal?.address} - ${terminal?.name}`;
                            });
                    }
                    
                    // Get restaurant cuisine types if they're not included in the response
                    if (!this.restaurant.cuisineTypes) {
                        Vue.axios
                            .get(`/restaurants/${parseInt(id)}/cuisine-types`)
                            .then(resp => {
                                this.restaurant.cuisineTypes = resp.data;
                            })
                            .catch(err => {
                                console.error('Error loading cuisine types:', err);
                            });
                    }
                })
                .catch(err => {
                    this.$root.$emit('showError', 'Ошибка загрузки данных.');
                });
        },
        methods: {
            labelType (label) {
                const labels = [];
                labels.push({ value: BUSINESS_LABEL.IS_NEW, label: 'Новый сервис' });
                labels.push({ value: BUSINESS_LABEL.VEGAN, label: 'Веган' });
                labels.push({ value: BUSINESS_LABEL.VERIFIED_MIRCITY, label: 'Првоерено МИРСИТИ' });

                for (const type of labels) {
                    if(label === type.value){
                        return type.label;
                    }
                }
                return '';
            },
            appendNull(number) {
                if (!number) {
                    return '00';
                }
                return number < 10 ? `0${number}` : number;
            },
            goBack() {
                this.$router.push({ path: '/restaurants' });
            },
            getBadge(status) {
                return status ? 'success' : 'secondary';
            },
            setSchedule(schedule) {
                if (schedule) {
                    this.schedule = schedule;
                }
            }
        },
    };
</script>
<style scoped lang="scss">

</style>
